export var EprTypes;
(function (EprTypes) {
    EprTypes["Rio"] = "rio";
    EprTypes["Tpp"] = "tpp";
    EprTypes["Generic"] = "generic";
})(EprTypes || (EprTypes = {}));
//# sourceMappingURL=epr.js.map